import { useTranslation } from 'react-i18next';

/**
 * Use in admin components to resolve keys from the admin namespace first,
 * then fall back to the main app translation namespace (e.g. error.somethingWentWrong).
 */
export const useAdminTranslation = () =>
  useTranslation(['admin', 'translation'], { nsMode: 'fallback' });
